import { gql } from '@apollo/client';

const GET_LAND_PARCELS = gql`
  query GetLandParcels(
    $topLeftLat: Float!
    $topLeftLng: Float!
    $btmRightLat: Float!
    $btmRightLng: Float!
  ) {
    landParcels(
      topLeftLat: $topLeftLat
      topLeftLng: $topLeftLng
      btmRightLat: $btmRightLat
      btmRightLng: $btmRightLng
    ) {
      items {
        id
        polygon {
          points {
            lat
            lng
          }
        }
        attributes {
          key
          label
          value
          visible
        }
        area
      }
      page
      limit
      hasNext
    }
  }
`;
export { GET_LAND_PARCELS };
